import './ReportsLoading.css';
import SeptimLoadingSpinner from '../Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';

const ReportsLoading = () => (
  <div className="white-box reports-loading">
    <SeptimLoadingSpinner />
  </div>
);

export default ReportsLoading;
